import React, { useState, useEffect } from "react";
import PeopleIcon from "@mui/icons-material/People";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

const SidebarCollection = (props) => {
  const {
    sidebarColActive,
    data,
    parent,
    setHeaderParams,
    setShowPopup,
    collectionIdArray,
    setSubNewFolder,
    parentCollectionIds,
    search,
    setSearch,
  } = props;

  const [openedFolders, setOpenedFolders] = useState([]);
  const navigate = useNavigate();
  const params = useParams();

  const toggleFolderOpen = (folderId) => {
    setOpenedFolders((prevOpenedFolders) => {
      if (prevOpenedFolders.includes(folderId)) {
        return prevOpenedFolders.filter((id) => id !== folderId);
      } else {
        return [...prevOpenedFolders, folderId];
      }
    });
  };

  return (
    <div className={`sidebar-collection  ${sidebarColActive ? "active" : ""}`}>
      <div className="header">
        <h1>My Collections</h1>
        <div className="search-collection">
          <SearchIcon />
          <input
            className="black-box"
            value={search}
            onChange={(e) => {
              const searchValue = e.target.value;

              navigate(
                `/saved/${params.id}?${
                  searchValue ? `search=${searchValue}` : ""
                }`
              );

              setSearch(searchValue);
            }}
            placeholder="Search collections"
          />
        </div>
      </div>
      <div className="tabs-container">
        <div className="tabs">
          <RenderMenuItem
            menuData={data}
            parentCollectionId={0}
            parent={parent}
            setHeaderParams={setHeaderParams}
            collectionIdArray={collectionIdArray}
            setSubNewFolder={setSubNewFolder}
            parentCollectionIds={parentCollectionIds}
            openedFolders={openedFolders}
            toggleFolderOpen={toggleFolderOpen}
          />
        </div>
      </div>
      <div className="footer">
        <div
          className="btn-text"
          onClick={() => setShowPopup((prevState) => !prevState)}
        >
          <AddIcon />
          <p>Create New</p>
        </div>
      </div>
    </div>
  );
};

function RenderMenuItem(props) {
  const {
    menuData,
    parentCollectionId,
    parent,
    setHeaderParams,
    collectionIdArray,
    setSubNewFolder,
    parentCollectionIds,
    openedFolders,
    toggleFolderOpen,
  } = props;

  const items = menuData.filter(
    (item) => item.parentCollectionID_lng === parentCollectionId
  );

  if (!items.length) return null;

  return items.map((item) => (
    <RenderItem
      item={item}
      key={item.collectionID_ids}
      menuData={menuData}
      parent={parent}
      setHeaderParams={setHeaderParams}
      collectionIdArray={collectionIdArray}
      setSubNewFolder={setSubNewFolder}
      parentCollectionIds={parentCollectionIds}
      openedFolders={openedFolders}
      toggleFolderOpen={toggleFolderOpen}
    />
  ));
}

const RenderItem = ({
  item,
  menuData,
  setHeaderParams,
  setSubNewFolder,
  collectionIdArray,
  parentCollectionIds,
  openedFolders,
  toggleFolderOpen,
}) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const includesParent = parentCollectionIds.includes(item.collectionID_ids);
  const isFolderOpen = openedFolders.includes(item.collectionID_ids);

  function hasNoChildren(collection) {
    const filterChild = menuData.filter(
      (item) => collection.collectionID_ids === item.parentCollectionID_lng
    );
    return filterChild.length === 0;
  }

  const handleClick = (item) => {
    const wasPreviouslyOpen = open;
    toggleFolderOpen(item.collectionID_ids);
    setOpen((prevOpen) => !prevOpen);
    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.get("search");

    if (
      !wasPreviouslyOpen ||
      (wasPreviouslyOpen && item.collectionID_ids !== Number(params.id))
    ) {
      navigate(
        `/saved/${item.collectionID_ids}${search ? `?search=${search}` : ""}`
      );
      setHeaderParams({
        created: item.createdDateTime_dtm,
        updated: item.lastUpdatedDateTime_dtm,
        title: item.collectionName_chr,
        isShared_ysn: item.isShared_ysn,
      });
    }
  };

  useEffect(() => {
    if (open) {
      const searchParams = new URLSearchParams(location.search);
      const search = searchParams.get("search");
      navigate(
        `/saved/${item.collectionID_ids}${search ? `?search=${search}` : ""}`
      );
      setHeaderParams({
        created: item.createdDateTime_dtm,
        updated: item.lastUpdatedDateTime_dtm,
        title: item.collectionName_chr,
        isShared_ysn: item.isShared_ysn,
      });
    }
  }, [open]);

  useEffect(() => {
    if (collectionIdArray.includes(item.collectionID_ids) && !isFolderOpen) {
      setOpen(true);
    }
  }, [params.id, collectionIdArray]);

  return (
    <div className={`tabs ${includesParent ? "no-padding" : ""}`}>
      {!includesParent && <div className="vertical-separator"></div>}

      <div
        className={`tab ${
          item.collectionID_ids === Number(params.id) ? "highlight" : ""
        }`}
        onClick={() => {
          handleClick(item);
        }}
      >
        <div className="flex">
          <div className="icon">
            {!hasNoChildren(item) &&
              (open ? <ExpandLessIcon /> : <ExpandMoreIcon />)}{" "}
          </div>
          <p className="flex">
            {item.collectionName_chr}{" "}
            {item.isShared_ysn && <PeopleIcon className="ml-1" />}
          </p>
        </div>

        <div className="end mr-2">
          <Tooltip title="Add New Subfolder">
            <AddIcon onClick={() => setSubNewFolder(true)} />
          </Tooltip>
        </div>
      </div>

      {open && (
        <RenderMenuItem
          menuData={menuData}
          parentCollectionId={item.collectionID_ids}
          setHeaderParams={setHeaderParams}
          collectionIdArray={collectionIdArray}
          setSubNewFolder={setSubNewFolder}
          parentCollectionIds={parentCollectionIds}
          openedFolders={openedFolders}
          toggleFolderOpen={toggleFolderOpen}
        />
      )}
    </div>
  );
};

export default SidebarCollection;
